module.exports = __webpack_public_path__ + "static/office_banners-f3552f7b4e4ff30d517ba9e59a440958.png";